import { render, staticRenderFns } from "./pingjiaBaogao.vue?vue&type=template&id=36a1b026&scoped=true"
import script from "./pingjiaBaogao.vue?vue&type=script&lang=js"
export * from "./pingjiaBaogao.vue?vue&type=script&lang=js"
import style0 from "./pingjiaBaogao.vue?vue&type=style&index=0&id=36a1b026&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a1b026",
  null
  
)

export default component.exports